export enum WalletsTermsColumns {
	id = "Id",
	status = "Status",
	org = "Org",
	name = "Name",
	bank = "Bank",
	createdAt = "Created At",
}

export type AllowedWalletsTermsColumns =
	| WalletsTermsColumns.id
	| WalletsTermsColumns.status
	| WalletsTermsColumns.org
	| WalletsTermsColumns.name
	| WalletsTermsColumns.bank
	| WalletsTermsColumns.createdAt
